import React from "react";
import "./Error.css";

function Error() {
  return (
    <div>
      <h1 className="err-1">404</h1>
      <h2 className="err-2">Page Not Found :/</h2>
    </div>
  );
}

export default Error;
